import { FC, useMemo } from 'react'
import classNames from 'classnames'
import { FlexRow, ResponsiveFlexRow } from '@/atoms/FlexContainers'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { ProgressBar } from '@/atoms/ProgressBar'
import { CaptionMD, TitleSM } from '@/atoms/Text'
import { ThemeContextProvider } from '@/contexts/ThemeContext'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  className?: string
  step: 1 | 2 | 3
}
const ChangeReservationBanner: FC<Props> = ({ step, className }) => {
  const { t } = useTranslate('tickets')

  const steps = useMemo(() => {
    return [
      {
        step: 1,
        label: t('showtime', 'Showtime'),
        percent: 12,
      },
      { step: 2, label: t('seats', 'Seats'), percent: 50 },
      { step: 3, label: t('checkout', 'Checkout'), percent: 100 },
    ]
  }, [t])

  return (
    <ThemeContextProvider isDarkMode>
      <ResponsiveFlexRow
        className={classNames(
          'gap-3 px-6 py-3 text-white relative z-30 bg-info-800 bg-black-transparent-t-t-light border-y border-[rgba(255,255,255,0.08)] md:justify-between',
          className,
        )}
      >
        <FlexRow className="gap-1">
          <TicketIcon size={16} color="info-200" />
          <TitleSM color="white" weight="semibold">
            {t('modifyReservation', 'Modify Reservation')}
          </TitleSM>
        </FlexRow>

        <div className="md:min-w-[400px]">
          <div className="relative mb-2">
            <ProgressBar value={steps[step - 1]?.percent ?? 0} barClassName="!bg-core-oxide-bright" />
            {step < 2 && <ProgressBarDot className="absolute left-1/2 top-0 -translate-x-1/2" />}
            {step < 3 && <ProgressBarDot className="absolute right-0 top-0" />}
          </div>
          <div className="flex justify-between">
            {steps.map(({ label }) => (
              <CaptionMD key={label} color="core-gray-400">
                {label}
              </CaptionMD>
            ))}
          </div>
        </div>
      </ResponsiveFlexRow>
    </ThemeContextProvider>
  )
}

const ProgressBarDot: FC<{ className?: string }> = ({ className }) => (
  <div className={classNames('w-3 h-3 rounded-full bg-white/50', className)} />
)

export default ChangeReservationBanner
